<div class="status-dialog">
  <form
    [formGroup]="form"
    (ngSubmit)="onSubmit()"
  >
    <header class="dialog__header">
      <h2 class="dialog__title">Confirm Status Transition</h2>
    </header>
    <mat-dialog-content fxLayout="column">
      <p class="status-dialog__info">The requester will be notified by mail. Would you like to add a comment?</p>
      <procure-input-textarea
        label="Comment"
        [control]="form.controls.comment"
      />
    </mat-dialog-content>
    <footer class="dialog__footer">
      <button
        id="status-dialog-cancel"
        type="button"
        procure-button
        variant="stroked"
        (click)="onCancel()"
      >
        Cancel
      </button>
      <button
        id="status-dialog-save"
        type="submit"
        procure-button
        color="primary"
        [matTooltip]="form.disabled || form.valid ? '' : 'The form contains validation errors.'"
        [suffix]="form.disabled || form.valid ? '' : 'warning'"
      >
        Save
      </button>
    </footer>
  </form>
</div>
